export default "__VITE_ASSET__fd448d5e__"